import * as React from "react";
import { MainSection } from "../../atoms/MainSection";
import styles from "./SectionView.scss";

// MainSectionがpaddingを決め打ちで持ってるので、それを0で上書きする
// margin, paddingを共通のユーティリティ(helpers/styles/*)で持つまでの暫定コンポーネント
export const SectionView = ({ children }: React.PropsWithChildren<unknown>) => {
  return <MainSection className={styles.SectionView}>{children}</MainSection>;
};
